import { render, staticRenderFns } from "./Computer.vue?vue&type=template&id=3c3677e0&scoped=true&"
import script from "./Computer.vue?vue&type=script&lang=js&"
export * from "./Computer.vue?vue&type=script&lang=js&"
import style0 from "./Computer.vue?vue&type=style&index=0&id=3c3677e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3677e0",
  null
  
)

export default component.exports